import React, { useState } from 'react';
import { Box, Typography, Link, Paper, Dialog, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import missionImg from '../images/801A9717.jpg';
import workImg from '../images/GF CLinic 2018 _2.jpg';
import storyImg from '../images/GF surgery 21 .jpg';
import './ServicesSection.css';

const ServicesSection = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({ title: '', desc: '', img: '' });

  const mission = {
    img: missionImg,
    title: 'Our Mission: Providing Quality Medical Care to Children in Need',
    desc: 'We work to ensure everyone has the chance to live a healthy, productive life.',
    fullDesc: `Our Mission\nAt Gundeti Foundation, we are passionate about providing quality medical care to children in need. Our organization was founded by Prof and Dr. Mohan Gundeti and Family in 2016. Since then, we have treated thousands of children with urological anomalies, and have established ourselves as a leader in pediatric urology in India. Our mission is to continue providing free or affordable medical care to underprivileged children, and to raise awareness about urological anomalies and their treatment.`,
    link: { label: 'Learn more about our role', href: '#' },
  };
  const work = {
    img: workImg,
    title: 'Our Services',
    desc: 'We provide free and affordable medical care to underprivileged children with urological anomalies in Solapur.',
    fullDesc: 'We offer a range of medical services to financially underprivileged children with urological anomalies in Solapur, Maharashtra, India. Our programs and services aim to provide free/affordable surgical and medical care to improve the health and wellbeing of underprivileged children in our community. Feel free to learn more about our programs and services below.',
    link: { label: 'Learn more about our work', href: '#' },
  };
  const story = {
    img: storyImg,
    title: 'Medical Support',
    desc: 'We provide free medical support for children in need.',
    fullDesc: `We understand that medical care can be a financial burden for underprivileged families. That's why we offer medical support to ensure that our patients receive the care they need without worrying about the cost. Our team of medical professionals is dedicated to providing the best urological anomaly care to financially underprivileged children in Solapur, Maharashtra, India. We offer a range of surgical and medical treatments to ensure the best possible outcome for our patients.`,
    link: { label: 'Explore our story', href: '#' },
  };

  const handleOpenModal = (title, desc, img) => {
    setModalContent({ title, desc, img });
    setModalOpen(true);
  };
  const handleCloseModal = () => setModalOpen(false);

  return (
    <Box
      className="services-container"
      sx={{
        background: '#faf8f3',
        borderRadius: '2.5rem',
        maxWidth: 1100,
        mx: 'auto',
        my: 4,
        p: { xs: 2, md: 6 },
        fontFamily: 'Poppins, Arial, sans-serif',
        boxShadow: '0 2px 16px 0 rgba(0,0,0,0.04)',
      }}
    >
      {/* Top: Mission */}
      <Box
        className="services-mission"
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1.7fr 1fr' },
          gap: 8,
          alignItems: 'center',
          mb: 7,
        }}
      >
        <Box
          className="services-mission-image"
          sx={{
            width: '100%',
            height: { xs: 260, md: 420 },
            borderRadius: '2.5rem',
            overflow: 'hidden',
            boxShadow: 3,
            minWidth: { md: 440 },
            maxWidth: { md: 600 },
            justifySelf: 'start',
          }}
        >
          <img
            src={mission.img}
            alt="Mission"
            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
          />
        </Box>
        <Box className="services-mission-content" sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%', minHeight: 140 }}>
          <Typography
            className="services-mission-title"
            variant="h6"
            sx={{
              fontWeight: 900,
              color: '#222',
              fontSize: { xs: '1.18rem', md: '1.35rem' },
              lineHeight: 1.3,
              textAlign: 'left',
              mb: 2,
            }}
          >
            {mission.title}
          </Typography>
          <Link
            className="services-mission-link"
            component="button"
            underline="none"
            sx={{
              color: '#1a73e8',
              fontWeight: 500,
              fontSize: '1rem',
              cursor: 'pointer',
              '&:hover': { textDecoration: 'underline' },
              p: 0,
              mt: 0.5,
              alignSelf: 'flex-start',
            }}
            onClick={() => handleOpenModal(mission.title, mission.fullDesc, mission.img)}
          >
            {mission.link.label}
          </Link>
        </Box>
      </Box>
      {/* Bottom: Work and Story */}
      <Box
        className="services-bottom"
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
          gap: 5,
        }}
      >
        {[work, story].map((item) => (
          <Paper
            key={item.title}
            className="services-card"
            elevation={0}
            sx={{
              display: 'flex',
              alignItems: 'stretch',
              gap: 3.5,
              p: 3,
              background: '#fff',
              borderRadius: '1.5rem',
              boxShadow: '0 2px 8px 0 rgba(0,0,0,0.04)',
              minHeight: 180,
              height: { xs: 180, md: 200 },
            }}
          >
            <Box
              className="services-card-image"
              sx={{
                width: { xs: 120, sm: 180, md: 220 },
                height: '100%',
                minHeight: 120,
                borderRadius: 4,
                overflow: 'hidden',
                flexShrink: 0,
                boxShadow: 3,
                mt: 1,
              }}
            >
              <img
                src={item.img}
                alt={item.title}
                style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
              />
            </Box>
            <Box className="services-card-content" sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Typography
                className="services-card-title"
                variant="subtitle1"
                sx={{
                  fontWeight: 900,
                  color: '#222',
                  mb: 0.5,
                  fontSize: '1.08rem',
                  textAlign: 'left',
                }}
              >
                {item.title}
              </Typography>
              <Typography
                className="services-card-desc"
                variant="body2"
                sx={{
                  color: '#444',
                  mb: 1,
                  fontWeight: 400,
                  fontSize: '0.98rem',
                  textAlign: 'left',
                }}
              >
                {item.desc}
              </Typography>
              <Link
                className="services-card-link"
                component="button"
                underline="none"
                sx={{
                  color: '#1a73e8',
                  fontWeight: 500,
                  fontSize: '0.98rem',
                  cursor: 'pointer',
                  '&:hover': { textDecoration: 'underline' },
                  p: 0,
                  mt: 0.2,
                  textAlign: 'left',
                  display: 'inline-block',
                }}
                onClick={() => handleOpenModal(item.title, item.fullDesc, item.img)}
              >
                {item.link.label}
              </Link>
            </Box>
          </Paper>
        ))}
      </Box>
      {/* Modal Popup - Styled like EventsSection */}
      <Dialog
        open={modalOpen}
        onClose={handleCloseModal}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 4, overflow: 'hidden', background: 'rgba(255,255,255,0.98)' }
        }}
      >
        {modalOpen && (
          <>
            <Box sx={{ position: 'relative', width: '100%', height: 220, overflow: 'hidden' }}>
              <img
                src={modalContent.img}
                alt={modalContent.title}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
              <IconButton
                onClick={handleCloseModal}
                sx={{ position: 'absolute', top: 12, right: 12, color: 'var(--color-white)', background: 'rgba(0,0,0,0.4)', '&:hover': { background: 'rgba(0,0,0,0.7)' } }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
            <DialogContent sx={{ p: { xs: 2, md: 4 } }}>
              <Typography variant="h5" sx={{ fontWeight: 900, color: 'var(--color-black)', mb: 2, letterSpacing: 1 }}>
                {modalContent.title}
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ fontWeight: 500, mb: 2 }}>
                {modalContent.desc}
              </Typography>
            </DialogContent>
          </>
        )}
      </Dialog>
    </Box>
  );
};

export default ServicesSection; 